module.exports = __webpack_public_path__ + "static/redundancy_icon-a4fd60c0e10db0ae539987de09bfea1f.svg";